import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, ChevronDown, Quote } from "lucide-react";

const REVIEWS = [
  { name: "Siddharth & Max 🐕", text: "Bhai maza aa gaya, mere Max ko nahlana ek task hota tha. Woofsy wale ghar aake itne aaram se kar gaye, I didn't even have to lift a finger. Definitely calling them again!", img: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&q=80" },
  { name: "Neha & Bella 🐶", text: "Bohot sahi service hai. Maine pehli baar try kiya tha to thoda doubt tha par groomer kaafi friendly the. Bella was actually enjoying her spa session. Pricing is also decent for the convenience.", img: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&q=80" },
  { name: "Aman & Rio 🐱", text: "The best part is they clean up everything after the grooming. Koi mess nahi chhoda ghar pe. Plus mere cat Rio ko bina daraye grooming kar diya. Very professional team.", img: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&q=80" },
  { name: "Priya & Bruno 🐾", text: "Usually pet salons mein itna wait karna padta hai, yaha time pe aa gaye the. Bruno ka haircut ekdam perfect kiya, just what I asked for. Super happy!", img: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&q=80" },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % REVIEWS.length), 6000);
    return () => clearInterval(t);
  }, []);

  const r = REVIEWS[i];

  return (
    <section id="reviews" data-testid="testimonials-section" className="relative py-24 sm:py-32 px-5 sm:px-8 bg-white/40">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-woofsy-primary mb-3 flex items-center justify-center gap-1.5">
          <span className="animate-tail-wag">🐕</span>
          <span>Happy Tails & Whisker Stories</span>
          <span className="animate-cat-tail">🐱</span>
        </p>
        <h2 className="font-heading font-bold text-3xl sm:text-5xl text-woofsy-dark mb-14">Pet parents adore Woofsy.</h2>

        <div className="relative min-h-[300px]">
          <AnimatePresence mode="wait">
            <motion.div key={i} data-testid="testimonial-card"
              initial={{ opacity: 0, y: 30, scale: 0.96 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: -30, scale: 0.96 }}
              transition={{ duration: 0.5 }}
              className="bg-white/70 backdrop-blur-2xl border border-white/60 rounded-[2rem] sm:rounded-[2.5rem] p-6 sm:p-10 md:p-14 shadow-[0_20px_50px_rgba(0,0,0,0.05)] relative flex flex-col justify-between group">
              
              {/* Background Quote Icon */}
              <div className="absolute top-4 left-4 sm:top-8 sm:left-8 text-woofsy-primary/10">
                <Quote className="w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 transform rotate-180" />
              </div>

              <div className="relative z-10 pt-4 sm:pt-0">
                <div className="flex justify-start gap-1.5 mb-6 sm:mb-8">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star key={k} className="w-5 h-5 sm:w-6 sm:h-6 fill-amber-400 text-amber-400 drop-shadow-sm" style={{ animationDelay: `${k * 0.1}s` }} />
                  ))}
                </div>
                
                <p className={`text-lg sm:text-xl md:text-2xl lg:text-3xl font-medium text-slate-800 leading-relaxed transition-all ${expanded ? "" : "line-clamp-4 sm:line-clamp-3"} text-left`}>
                  "{r.text}"
                </p>
                
                <div className="mt-8 flex flex-row items-center justify-between gap-2 sm:gap-6">
                  {/* User Profile */}
                  <div className="flex items-center gap-3 sm:gap-4 justify-start">
                    <div className="relative shrink-0">
                      <div className="absolute inset-0 bg-gradient-to-tr from-woofsy-primary to-orange-300 rounded-full blur-[6px] opacity-70"></div>
                      <img src={r.img} alt={r.name} className="relative w-12 h-12 sm:w-16 sm:h-16 rounded-full object-cover ring-2 sm:ring-4 ring-white shadow-md" />
                    </div>
                    <div className="text-left">
                      <span className="block font-heading font-extrabold text-sm sm:text-lg text-slate-900 leading-tight">{r.name}</span>
                      <span className="text-[9px] sm:text-xs text-emerald-600 font-bold bg-emerald-50 px-2 py-0.5 rounded-full inline-block mt-1 border border-emerald-100">Verified</span>
                    </div>
                  </div>

                  {/* Bottom Right Down Arrow Toggle */}
                  <div className="flex justify-end shrink-0">
                    <button
                      onClick={() => setExpanded(!expanded)}
                      data-testid="down-arrow-testimonial"
                      className="flex items-center gap-1 sm:gap-1.5 text-[10px] sm:text-xs font-bold text-woofsy-primary hover:text-white px-3 sm:px-5 py-2 sm:py-2.5 rounded-full bg-orange-50 hover:bg-woofsy-primary border border-orange-100 hover:border-woofsy-primary shadow-sm transition-all"
                      title={expanded ? "Collapse review" : "Expand full review"}
                    >
                      <span>{expanded ? "Hide" : "Read More"}</span>
                      <motion.div animate={{ rotate: expanded ? 180 : 0 }} transition={{ duration: 0.2 }}>
                        <ChevronDown className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                      </motion.div>
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex justify-center items-center gap-2 mt-10">
          {REVIEWS.map((_, k) => (
            <div key={k} data-testid={`testimonial-dot-${k}`} onClick={() => { setI(k); setExpanded(false); }}
              className={`h-2.5 rounded-full cursor-pointer transition-all ${k === i ? "w-8 bg-woofsy-primary" : "w-2.5 bg-woofsy-primary/30"}`} 
              style={{ minHeight: "10px", maxHeight: "10px" }} />
          ))}
        </div>
      </div>
    </section>
  );
}
